import { render, staticRenderFns } from "./ProductSheetDrawing.vue?vue&type=template&id=a986abc4&scoped=true&lang=pug&"
import script from "./ProductSheetDrawing.vue?vue&type=script&lang=js&"
export * from "./ProductSheetDrawing.vue?vue&type=script&lang=js&"
import style0 from "./ProductSheetDrawing.vue?vue&type=style&index=0&id=a986abc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a986abc4",
  null
  
)

export default component.exports